import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { ICaseBattle } from '../interfaces/case-battles.interface';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { NgParticlesService, NgxParticlesModule } from '@tsparticles/angular';
import NumberFlow from 'number-flow';
import { Engine, ISourceOptions } from '@tsparticles/engine';
import { SessionService } from '@core/services/session.service';
import { BalanceType } from '@core/types/balance.type';
import { loadSlim } from '@tsparticles/slim';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { getDropsSumByBattle } from '../utils/utils';

@Component({
  selector: 'app-cb-battle-finished',
  imports: [NgxParticlesModule, BalanceIconComponent, CostComponent],
  templateUrl: './cb-battle-finished.component.html',
  styleUrl: './cb-battle-finished.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CbBattleFinishedComponent {
  battle = input.required<ICaseBattle>();
  balance = input.required<BalanceType>();

  rehostBattle = output();

  private ngParticlesService = inject(NgParticlesService);
  public sessionService = inject(SessionService);

  particlesOptions: ISourceOptions = {
    fullScreen: { enable: false },
    particles: {
      number: {
        value: 40,
      },
      color: {
        value: ['#ffffff'],
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: {
          default: 'out',
        },
        random: true,
        speed: 1.5,
        straight: false,
      },
      opacity: {
        value: { min: 0.17, max: 0.5 },
      },
      size: {
        value: { min: 1, max: 1.2 },
      },
      wobble: {
        enable: false,
      },
    },
  };

  totalValue = viewChild.required<ElementRef<NumberFlow>>('totalValue');

  ngAfterViewInit() {
    if (this.totalValue()?.nativeElement) {
      const formatOptions = {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      const animationOptionsTotal = {
        duration: 500,
        //easing: 'linear',
      };

      this.totalValue()!.nativeElement.format = { ...formatOptions };

      this.totalValue()!.nativeElement.transformTiming = {
        ...animationOptionsTotal,
      };
      this.totalValue()!.nativeElement.spinTiming = {
        ...animationOptionsTotal,
      };
      this.totalValue()!.nativeElement.opacityTiming = {
        ...animationOptionsTotal,
      };

      this.totalValue()!.nativeElement.locales = 'en-US';

      this.totalValue()!.nativeElement.update(0);
      this.totalValue()!.nativeElement.update(
        getDropsSumByBattle(this.battle())
      );
    }
  }

  ngOnInit() {
    this.ngParticlesService.init(async (engine: Engine) => {
      await loadSlim(engine);
    });
  }
}
